<template>
  <header
    class="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800"
  >
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-14">
        <NuxtLink to="/" class="flex items-center">
          <img src="/qmdash-logo-new.png" alt="Qmdash" class="h-9 w-auto" />
        </NuxtLink>
        <div class="flex items-center">
          <template v-if="userStore.user">
            <UDropdownMenu :items="dropdownItems" :content="{ align: 'end' }">
              <UButton
                color="neutral"
                variant="ghost"
                trailing-icon="i-heroicons-chevron-down"
              >
                {{ userStore.user.email || userStore.userId }}
              </UButton>
            </UDropdownMenu>
          </template>
          <template v-else>
            <UButton to="/login" color="neutral" variant="ghost">Login</UButton>
          </template>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { useUserStore } from "~/stores/user";

const userStore = useUserStore();

const dropdownItems = [
  [
    {
      label: "Dashboard",
      icon: "i-heroicons-home",
      to: "/dashboard",
    },
    {
      label: "Settings",
      icon: "i-heroicons-cog-6-tooth",
      to: "/settings",
    },
  ],
  [
    {
      label: "Logout",
      icon: "i-heroicons-arrow-right-start-on-rectangle",
      onSelect: () => handleLogout(),
    },
  ],
];

const config = useRuntimeConfig();

// Logout is a full-page navigation: the API ends the session and the Zitadel session,
// then redirects back to /login.
const handleLogout = async () => {
  userStore.clearUser();

  const returnUrl = `${window.location.origin}/login`;
  await navigateTo(
    `${config.public.apiBaseUrl}/auth/logout?returnUrl=${encodeURIComponent(returnUrl)}`,
    { external: true },
  );
};
</script>
